import * as React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import {
  renderTextWithFootnotesReferencesV2,
  ConsumptionsAndEmissions,
} from '@oneaudi/feature-app-utils';
import type { OneGraphServiceV1 } from '@oneaudi/onegraph-service';
import type { Logger } from '@feature-hub/logger';
import type { BasicTeaserContent, BasicTeaserServices } from '../../types';

interface LegalInfoProps
  extends Pick<BasicTeaserContent, 'consumptionAndEmissions' | 'disclaimers'>,
    BasicTeaserServices {
  mediaPosition?: BasicTeaserContent['asset']['mediaPosition'];
  oneGraphService: OneGraphServiceV1;
  loggerService?: Logger;
}

const LegalInfoContainer = styled.div<{
  mediaPosition?: BasicTeaserContent['asset']['mediaPosition'];
}>`
  padding-block-start: var(--spacing-relative-xl);

  .consumption-text {
    margin-block-end: var(--spacing-relative-xs);
  }
`;

export const LegalInfo = ({
  consumptionAndEmissions,
  localeService,
  oneGraphService,
  loggerService,
  disclaimers,
  mediaPosition,
}: LegalInfoProps): React.ReactElement | null => {
  const hasContent =
    consumptionAndEmissions?.filter((x) => !!x).length || disclaimers?.filter((x) => !!x).length;

  if (!hasContent) return null;

  return (
    <LegalInfoContainer mediaPosition={mediaPosition}>
      {consumptionAndEmissions && (
        <Text
          className="consumption-text"
          variant={{
            type: 'copy',
            order: process.env.IS_LEGACY ? '2' : '3',
            style: 'normal',
          }}
        >
          <ConsumptionsAndEmissions
            ids={consumptionAndEmissions}
            localeService={localeService}
            oneGraphService={oneGraphService}
            logger={loggerService}
          />
        </Text>
      )}
      {disclaimers?.map((x, i) => (
        <Text
          key={['d', i, x].join('_')}
          variant={{
            type: 'copy',
            order: process.env.IS_LEGACY ? '2' : '3',
            style: 'normal',
          }}
        >
          {renderTextWithFootnotesReferencesV2(x)}
        </Text>
      ))}
    </LegalInfoContainer>
  );
};
